export const EquipmentDetail = () => {}
